/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_welcome_option_2_description = /** @type {(inputs: {}) => string} */ () => {
	return `Potenciamos lo que quieres construir`
};

const en_organization_welcome_option_2_description = /** @type {(inputs: {}) => string} */ () => {
	return `We empower what you want to build`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_welcome_option_2_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_welcome_option_2_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_welcome_option_2_description", locale)
	if (locale === "es") return es_organization_welcome_option_2_description(inputs)
	return en_organization_welcome_option_2_description(inputs)
};
export { organization_welcome_option_2_description as "organization.welcome.option_2_description" }